import React, { useEffect, useState } from "react";
import rightArrow from "Assests/Icons/right-arrow-7288805.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../Redux/Actions/alert.action";
import { setHmoStep1Action } from "../../Redux/Actions/hmo.action";
import "./HMOs.css";
// import useMetaTags from "Components/Hooks/useMetaTags";
import MetaDetails from "Components/MetaDetails/MetaDetails";

const Step1 = () => {
  const step1Data = useSelector((state) => state.setHmoStepReducer.step1);
  const [formData, setFormData] = useState({
    hpd_branch: step1Data?.hpd_branch,
    data_of_visit: step1Data?.data_of_visit,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // useEffect(() => {
  //     if (Object.keys(step1Data).length > 0) {
  //         setFormData({
  //             branch : step1Data.branch,
  //             date : step1Data.date
  //         })
  //     }
  // }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("form data", formData);
    if (Object.values(formData).includes(undefined)) {
      dispatch(setAlert("error", "All fields are required!"));
    } else {
      dispatch(setHmoStep1Action(formData));
      navigate("/HMOs/fill-out-patient-details");
    }
  };

  // Using Custom Hook for adding Meta Title and Meta Description for Page
  // useMetaTags("Nederlands Diagnostics Promotes HMO Partnerships","HMO partners can book appointments with Nederlands Diagnostics for their members. Book diagnostic tests and consultations conveniently to ensure timely healthcare delivery.")

  return (
    <>
      <MetaDetails
        title="Nederlands Diagnostics Promotes HMO Partnerships"
        description="HMO partners can book appointments with Nederlands Diagnostics for their members. Book diagnostic tests and consultations conveniently to ensure timely healthcare delivery."
      />

      <form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
        className="hmo-step-1"
      >
        <div className="hmo-para-Wrapper">
          <p>
            Complete the form below to process your HMO requests at least 2 days
            prior to your visit.
          </p>
          <p>
            You will be required to upload your valid ID, HMO card, and test
            request issued by an HMO accredited doctor with corresponding
            diagnosis. Unmatched details may result in delay of approval. We
            will contact you to verify some information if necessary.​
          </p>
          <p>
            Kindly note submission of this form should be at least 2 days before
            the scheduled date and that approved requests are only valid within
            2 days from appointment date.
          </p>
          <p>
            You will receive a confirmation email once your request has been
            successfully received. Please bear in mind that you will receive
            another confirmation email or phone call from our staff once your
            booking and approval have been confirmed.
          </p>
        </div>

        
        

        
      </form>
    </>
  );
};

export default Step1;
